/** @jsx jsx */
import { css, jsx } from '@compiled/react';

import { WidthObserver } from '@atlaskit/width-detector/width-observer';

import { fg } from '@confluence/feature-gating';
import { useIsSSROrHydrating } from '@confluence/ssr-utilities/entry-points/useIsSSROrHydrating.ts';

const baseStyles = css({
	position: 'relative',
	overflow: 'visible',
});

// This z-index value is higher than the sticky table header
const zIndex11Styles = css({
	zIndex: '11',
});

// This z-index value is higher than the content header
const zIndex13Styles = css({
	zIndex: '13',
});

const popupPortalContainerId = 'highlight-actions-portal-container';
export { popupPortalContainerId };

let popupPortalContainerWidth;

function onResize(width) {
	// Hide popup when the container is resized.
	if (width !== popupPortalContainerWidth) {
		popupPortalContainerWidth = width;
		window.dispatchEvent(new CustomEvent('highlight-actions.container.resized'));
	}
}

export const HighlightActionsProvider = (): JSX.Element => {
	return (
		<div
			css={[
				baseStyles,
				// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
				fg('confluence_highlight_actions_zindex_fix') ? zIndex11Styles : zIndex13Styles,
			]}
			id={popupPortalContainerId}
		>
			<WidthObserver setWidth={onResize} />
		</div>
	);
};

// Only renders the Highlight Actions Provider if we're using Nav4
export const HighlightActionsProviderForNav4 = (): JSX.Element | null => {
	const renderServerPlaceholder = useIsSSROrHydrating();
	// render null for first render during hydration to prevent mismatch
	if (renderServerPlaceholder) {
		return null;
	}
	return <HighlightActionsProvider />;
};
